import { CalendarClock, CopyCheck, Eraser } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";

const DAYS = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];

export const scheduleError = (rows = []) => {
  const bad = rows.find((r) => !r.start || !r.end || r.end <= r.start);
  return bad ? `${DAYS[bad.day]}: o horário de fim precisa ser depois do início.` : "";
};

function DayRow({ day, row, onToggle, onTime }) {
  const on = !!row;
  const bad = on && (!row.start || !row.end || row.end <= row.start);
  return (
    <div className={`flex flex-wrap items-center gap-2 rounded-lg border px-3 py-2 transition-colors ${on ? "bg-primary/5" : ""} ${bad ? "border-red-500/60" : ""}`} data-testid={`schedule-day-${day}`}>
      <label className="flex w-32 items-center gap-2 text-sm"><Switch checked={on} onCheckedChange={onToggle} data-testid={`schedule-day-${day}-switch`} />{DAYS[day]}</label>
      <div className="flex min-w-0 flex-1 basis-full items-center gap-2 sm:basis-auto">
        <Input type="time" value={row?.start || ""} disabled={!on} onChange={(e) => onTime("start", e.target.value)} className="h-9 min-w-0 flex-1 sm:max-w-[130px]" data-testid={`schedule-day-${day}-start`} />
        <span className="text-xs text-muted-foreground">até</span>
        <Input type="time" value={row?.end || ""} disabled={!on} onChange={(e) => onTime("end", e.target.value)} className="h-9 min-w-0 flex-1 sm:max-w-[130px]" data-testid={`schedule-day-${day}-end`} />
      </div>
    </div>
  );
}

export function ScheduleEditor({ value = [], onChange }) {
  const byDay = Object.fromEntries(value.map((r) => [r.day, r]));
  const first = value[0];
  const put = (rows) => onChange([...rows].sort((a, b) => a.day - b.day));
  const toggle = (day, on) => put(on ? [...value, { day, start: first?.start || "08:00", end: first?.end || "18:00" }] : value.filter((r) => r.day !== day));
  const setTime = (day, k, v) => put(value.map((r) => (r.day === day ? { ...r, [k]: v } : r)));
  const err = scheduleError(value);
  return (
    <div className="col-span-2 mt-2 min-w-0 space-y-3 rounded-xl border p-4" data-testid="product-schedule">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="flex items-center gap-2 text-sm font-semibold"><CalendarClock className="h-4 w-4 text-primary" />Agendamento por dias e horários</p>
          <p className="text-xs text-muted-foreground" data-testid="product-schedule-hint">{value.length ? "Fora destes dias e horários (horário de Brasília) o produto some do cardápio digital e do delivery." : "Nenhum dia marcado: o produto segue os botões acima normalmente."}</p>
        </div>
        {value.length > 0 && <div className="flex gap-1">
          {value.length < 7 && <Button type="button" variant="ghost" size="sm" onClick={() => put(DAYS.map((_, day) => ({ day, start: first.start, end: first.end })))} data-testid="product-schedule-all-days"><CopyCheck className="mr-1 h-4 w-4" />Todos os dias</Button>}
          <Button type="button" variant="ghost" size="sm" onClick={() => onChange([])} data-testid="product-schedule-clear"><Eraser className="mr-1 h-4 w-4" />Limpar</Button>
        </div>}
      </div>
      <div className="grid grid-cols-1 gap-2">{DAYS.map((_, day) => <DayRow key={day} day={day} row={byDay[day]} onToggle={(on) => toggle(day, on)} onTime={(k, v) => setTime(day, k, v)} />)}</div>
      {err && <p className="text-xs text-red-500" data-testid="product-schedule-error">{err}</p>}
    </div>
  );
}
